export const FishIcons = () => (
	<>
		<svg
			width="123.3rem"
			height="64.4rem"
			fill="none"
			viewBox="0 0 1233 644"
			className="hide-sm"
			style={{ position: 'absolute', top: '7.2rem', left: '10.9rem' }}
		>
			<g stroke="#fff" strokeLinejoin="round" strokeWidth="3.209" opacity=".1">
				<path d="M16.058 16.887c3.513-12.476 30.757-21.83 38.294-4.074-1.12 12.222-27.736 19.894-38.294 4.074Zm0 0s-8.3 12.986-10.694 13.24c-.895.096-.741-1.614-.197-3.791 1.366-5.468.545-11.202-2.024-16.218-1.063-2.075-1.546-3.795-.325-3.925 3.19-.34 13.24 10.694 13.24 10.694Z" />
				<path strokeLinecap="round" d="M42.3 13.289c-.339-3.191 4.448-3.7 4.787-.51" />
			</g>
			<g stroke="#fff" strokeLinejoin="round" strokeWidth="2.147" opacity=".1">
				<path d="M771.517 21.788c.829-8.632 17.653-18.031 24.727-7.238.717 8.18-15.894 16.397-24.727 7.238Zm0 0s-3.92 9.537-5.465 9.99c-.578.169-.68-.975-.581-2.473.249-3.763-.974-7.44-3.262-10.437-.946-1.24-1.469-2.314-.681-2.545 2.061-.603 9.989 5.465 9.989 5.465Z" />
				<path strokeLinecap="round" d="M788.366 16.296c-.603-2.06 2.488-2.965 3.091-.904" />
			</g>
			<g stroke="#fff" strokeLinejoin="round" strokeWidth="1.451" opacity=".1">
				<path d="M822.107 26.41c.56-5.833 11.928-12.184 16.708-4.891.485 5.527-10.739 11.08-16.708 4.89Zm0 0s-2.649 6.444-3.693 6.75c-.391.114-.46-.659-.393-1.671.168-2.543-.658-5.027-2.204-7.053-.64-.837-.993-1.563-.46-1.72 1.392-.407 6.75 3.694 6.75 3.694Z" />
				<path strokeLinecap="round" d="M833.492 22.699c-.408-1.393 1.681-2.004 2.089-.612" />
			</g>
			<g stroke="#fff" strokeLinejoin="round" strokeWidth="3.209" opacity=".1">
				<path d="M1106.67 189.124c7.9-10.275 36.67-8.827 37.06 10.458-5.58 10.929-33.14 8.154-37.06-10.458Zm0 0s-12.54 8.968-14.85 8.315c-.87-.245-.09-1.774 1.22-3.593 3.31-4.568 4.68-10.196 4.16-15.808-.22-2.321-.03-4.097 1.15-3.764 3.09.872 8.32 14.85 8.32 14.85Z" />
				<path strokeLinecap="round" d="M1132.37 195.543c.87-3.089 5.5-1.781 4.63 1.307" />
			</g>
			<g stroke="#fff" strokeLinejoin="round" strokeWidth="3.209" opacity=".1">
				<path d="M357.463 628.244c3.382-12.513 30.525-22.154 38.249-4.479-.991 12.232-27.524 20.186-38.249 4.479Zm0 0s-8.162 13.072-10.553 13.352c-.894.105-.758-1.606-.237-3.789 1.308-5.482.426-11.207-2.196-16.196-1.084-2.063-1.586-3.778-.366-3.92 3.187-.374 13.352 10.553 13.352 10.553Z" />
				<path strokeLinecap="round" d="M383.666 624.367c-.373-3.187 4.408-3.747 4.781-.56" />
			</g>
			<g stroke="#fff" strokeLinejoin="round" strokeWidth="3.209" opacity=".1">
				<path d="M1192.4 536.042c1.74-12.844 27.41-25.901 37.35-9.369.59 12.259-24.69 23.564-37.35 9.369Zm0 0s-6.41 14.015-8.75 14.601c-.87.219-.96-1.495-.72-3.727.59-5.605-1.02-11.168-4.26-15.778-1.35-1.906-2.06-3.542-.87-3.841 3.11-.781 14.6 8.745 14.6 8.745Z" />
				<path strokeLinecap="round" d="M1217.88 528.823c-.78-3.113 3.89-4.284 4.67-1.171" />
			</g>
		</svg>
		<svg
			width="59"
			height="41"
			fill="none"
			viewBox="0 0 59 41"
			className="sm-only"
			style={{ position: 'absolute', top: '2rem', right: '4rem' }}
		>
			<g stroke="#fff" strokeLinejoin="round" strokeWidth="3.209" opacity=".1">
				<path d="M18.032 23.727C18.741 10.785 43.29-4.284 54.517 11.4c1.572 12.172-22.73 25.464-36.485 12.327Zm0 0s-5.268 14.484-7.549 15.254c-.853.288-1.075-1.414-1.019-3.657.141-5.635-1.91-11.051-5.512-15.387-1.49-1.793-2.336-3.366-1.173-3.759 3.04-1.027 15.253 7.55 15.253 7.55Z" />
				<path strokeLinecap="round" d="M42.859 14.492c-1.028-3.04 3.533-4.581 4.56-1.54" />
			</g>
		</svg>
	</>
);

export const PersonIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" viewBox="0 0 56 56">
		<path
			fill="#F0F6FF"
			stroke="#14489D"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="4"
			d="M22.167 23.333a8.167 8.167 0 1 0 0-16.333 8.167 8.167 0 0 0 0 16.333Z"
		/>
		<path
			stroke="#14489D"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="4"
			d="m37.334 23.333 7-7 7 7M4.667 47.6V49h35v-1.4c0-5.227 0-7.84-1.017-9.837a9.334 9.334 0 0 0-4.08-4.079c-1.996-1.017-4.61-1.017-9.836-1.017H19.6c-5.227 0-7.84 0-9.837 1.017a9.333 9.333 0 0 0-4.079 4.08c-1.017 1.996-1.017 4.61-1.017 9.836Z"
		/>
	</svg>
);

export const SpeedometerIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="56" height="55" fill="none" viewBox="0 0 56 55">
		<path
			stroke="#14489D"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="4"
			d="M28.317 8C15.693 8 5.46 18.233 5.46 30.857c0 5.977 1.958 11.927 5.714 16H45.46c3.756-4.073 5.714-10.023 5.714-16C51.174 18.234 40.941 8 28.317 8Z"
		/>
		<path
			fill="#F0F6FF"
			stroke="#14489D"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="4"
			d="M28.317 38.857a4.571 4.571 0 1 0 0-9.143 4.571 4.571 0 0 0 0 9.143Z"
		/>
		<path
			stroke="#14489D"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="4"
			d="M28.317 22.857v6.858m0-16.001V16M11.174 32h2.286m2.286-11.429 1.616 1.616M43.174 32h2.285m-5.713-9.812 1.616-1.617"
		/>
	</svg>
);

export const DocumentIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" viewBox="0 0 56 56">
		<path
			stroke="#14489D"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="4"
			d="M44.332 4.667H11.665A2.333 2.333 0 0 0 9.332 7v42a2.333 2.333 0 0 0 2.333 2.334h32.667A2.333 2.333 0 0 0 46.665 49V7a2.333 2.333 0 0 0-2.333-2.333ZM19.832 35h16.333m-16.333 7h8.167"
		/>
		<path
			stroke="#14489D"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="4"
			d="M35 15.167 25.667 24.5 21 19.834"
		/>
	</svg>
);
